/*
 * AutoChimp Shipping Protection — native replacement for the Simply Insurance app.
 * Reads config from <script data-ac-sp-config> (rendered by snippets/ac-shipping-protection.liquid).
 *
 * Rules
 *  - Fee = the variant whose storefront (GST-inc) price is nearest 5% of the goods subtotal
 *    (protection line excluded); never the $0.00 variant; capped by the top variant.
 *  - Pre-selected: added automatically unless cart.attributes.shipping_protection == 'declined'.
 *  - Toggle off  -> removes the line, sets attribute 'declined'.
 *  - Toggle on   -> adds the line, sets attribute 'accepted'.
 *  - Cart changes elsewhere (qty, remove, add) -> fee re-tiered automatically.
 *  - Goods subtotal 0 -> protection removed.
 */
(function () {
  'use strict';
  if (window.ACShippingProtection) return;

  var cfgEl = document.querySelector('[data-ac-sp-config]');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var busy = false;      // true while we are changing the cart ourselves
  var dirty = false;     // a refresh was requested while busy; run again when done
  var pending = null;    // debounce timer
  var lastCart = null;   // most recent cart we have seen (for instant optimistic updates)
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // Our own calls go through origFetch so the hook below only sees the theme's calls.
  function api(path, body) {
    return origFetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function getCart() {
    return origFetch(root + 'cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { lastCart = c; return c; });
  }

  function formatMoney(cents) {
    var fmt = cfg.moneyFormat || '${{amount}}';
    var amount = (cents / 100);
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var out;
    switch (key) {
      case 'amount_no_decimals': out = Math.round(amount).toLocaleString('en-AU'); break;
      case 'amount_with_comma_separator': out = amount.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'); break;
      default: out = amount.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  function analyse(cart) {
    var goods = 0, line = null;
    cart.items.forEach(function (it) {
      if (it.handle === cfg.handle) { line = it; } else { goods += it.final_line_price; }
    });
    // Nearest non-zero tier to 5% of goods (tier prices are GST-inclusive, not exact 50c steps)
    var target = goods * cfg.rate, fee = 0, best = Infinity;
    Object.keys(cfg.tiers).forEach(function (k) {
      var price = Number(k);
      if (!price) return;
      var diff = Math.abs(price - target);
      if (diff < best || (diff === best && price > fee)) { best = diff; fee = price; }
    });
    var variantId = cfg.tiers[String(fee)];
    return {
      goods: goods,
      fee: fee,
      variantId: variantId,
      line: line,
      declined: cart.attributes && cart.attributes.shipping_protection === 'declined'
    };
  }

  function render(cart, a) {
    document.querySelectorAll('[data-ac-sp]').forEach(function (w) {
      w.classList.toggle('ac-sp--empty', a.goods === 0);
      var t = w.querySelector('[data-ac-sp-toggle]');
      var choice = queuedChoice || activeChoice;
      var declined = choice ? choice === 'declined' : a.declined;
      if (t) t.checked = !declined && a.goods > 0;
      var p = w.querySelector('[data-ac-sp-price]');
      if (p) p.textContent = formatMoney(a.fee);
      var d = w.querySelector('[data-ac-sp-desc]');
      if (d) d.textContent = a.declined ? cfg.declinedDesc : cfg.acceptedDesc;
    });
    // Empire cart page + add-to-cart banner totals
    var total = formatMoney(cart.total_price);
    document.querySelectorAll('[data-cart-total], [data-atc-banner-cart-subtotal]').forEach(function (el) {
      el.textContent = total;
    });
    document.querySelectorAll('[data-cartitem]').forEach(function (row) {
      var id = row.getAttribute('data-cartitem-id');
      var isSp = Object.keys(cfg.tiers).some(function (k) { return String(cfg.tiers[k]) === id; });
      if (isSp) row.classList.add('cart-item--protection');
    });
  }

  function setBusy(on) {
    busy = on;
    document.querySelectorAll('[data-ac-sp]').forEach(function (w) {
      if (on) w.setAttribute('data-ac-sp-busy', ''); else w.removeAttribute('data-ac-sp-busy');
    });
  }

  // Bring the cart in line with the rules, in as few requests as possible, then re-render.
  // choice (optional): 'accepted' | 'declined' — the customer's new answer, written with the same request.
  // (/cart/update.js only changes lines already in the cart, so adds go through /cart/add.js.)
  function reconcile(cart, choice) {
    var attrs = choice ? { shipping_protection: choice } : null;
    var declined = choice ? choice === 'declined' : (cart.attributes && cart.attributes.shipping_protection === 'declined');
    var a = analyse(cart);
    var wantLine = !declined && a.goods > 0 && a.variantId;
    var ops = null;

    if (!wantLine && a.line) {
      var rm = {}; rm[a.line.key] = 0;
      ops = api('cart/update.js', attrs ? { updates: rm, attributes: attrs } : { updates: rm });
    } else if (wantLine && (!a.line || a.line.variant_id !== a.variantId || a.line.quantity !== 1)) {
      var fix = {};
      if (a.line) fix[a.line.key] = 0;
      ops = api('cart/add.js', { items: [{ id: a.variantId, quantity: 1 }] }).then(function () {
        return api('cart/update.js', { updates: fix, attributes: { shipping_protection: 'accepted' } });
      });
    } else if (attrs) {
      ops = api('cart/update.js', { attributes: attrs });
    }
    var afterOps = ops ? ops.then(function (fresh) {
      return (!fresh || !fresh.items) ? getCart() : fresh;
    }) : Promise.resolve(cart);

    return afterOps.then(sinkProtection).then(function (fresh) {
      if (fresh === cart && !ops) return cart; // nothing changed
      lastCart = fresh;
      // Show the right numbers immediately, then let the server re-render the cart section.
      render(fresh, analyse(fresh));
      return rerenderCartSection().then(function () { return fresh; });
    });
  }

  // Checkout lists cart lines newest-first, so a freshly (re)added protection line lands at
  // the top of the order summary. Keep it as the OLDEST line: when it isn't, re-create the
  // goods lines above it (zero them, then add them back in one request, in display order).
  // Adding goods copies before zeroing would double quantities and trip inventory limits,
  // so it is zero-then-add, with one retry so a failed add cannot leave the cart empty.
  function sinkProtection(cart) {
    if (!cart || !cart.items || cart.items.length < 2) return Promise.resolve(cart);
    var last = cart.items[cart.items.length - 1];
    var p = null;
    cart.items.forEach(function (it) { if (it.handle === cfg.handle) p = it; });
    if (!p || last === p) return Promise.resolve(cart);
    var goods = cart.items.filter(function (it) { return it !== p; });
    var zero = {};
    goods.forEach(function (g) { zero[g.key] = 0; });
    // cart.items is newest-first; /cart/add.js creates lines in array order (first = oldest),
    // so send the goods reversed to keep their current on-screen order.
    var items = goods.slice().reverse().map(function (g) {
      var it = { id: g.variant_id, quantity: g.quantity, properties: g.properties || {} };
      if (g.selling_plan_allocation && g.selling_plan_allocation.selling_plan) it.selling_plan = g.selling_plan_allocation.selling_plan.id;
      return it;
    });
    var readd = function () { return api('cart/add.js', { items: items }); };
    return api('cart/update.js', { updates: zero })
      .then(readd)
      .then(function (r) { if (!r || r.status) return readd(); return r; })
      .then(getCart, getCart);
  }

  // Re-render the cart section from the server and let Empire re-initialise it.
  // Empire's sections manager listens for the Theme Editor events, so firing
  // shopify:section:unload / shopify:section:load on the wrapper rebinds the +/- buttons,
  // remove links and shipping calculator against the new DOM.
  function rerenderCartSection() {
    var sec = document.querySelector('[data-section-type="static-cart"]');
    if (!sec) return Promise.resolve();
    var id = sec.getAttribute('data-section-id');
    var wrap = sec.parentNode;
    return origFetch(root + 'cart?section_id=' + encodeURIComponent(id) + '&_=' + Date.now(), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('shopify-section-' + id) || doc.body.firstElementChild;
        if (!fresh) return;
        wrap.dispatchEvent(new CustomEvent('shopify:section:unload', { bubbles: true, detail: { sectionId: id } }));
        wrap.innerHTML = fresh.innerHTML;
        wrap.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: id } }));
      })
      .catch(function () {});
  }

  function refresh() {
    if (busy) { dirty = true; return Promise.resolve(); }
    setBusy(true);
    dirty = false;
    return getCart().then(function (cart) {
      project(cart);
      return reconcile(cart);
    }).then(function (cart) {
      render(cart, analyse(cart));
    }).catch(function (e) {
      if (window.console) console.warn('[shipping-protection]', e);
    }).then(finish);
  }

  function scheduleRefresh() {
    // Empire has just morphed the section with server totals that still include the old
    // fee line; repaint the projected numbers immediately, then reconcile for real.
    if (lastCart) project(lastCart);
    clearTimeout(pending);
    pending = setTimeout(refresh, 60);
  }

  // Customer toggles the switch. If we are mid-request the choice is queued and applied
  // as soon as the current work finishes, so a click is never silently dropped.
  var queuedChoice = null;   // clicked while busy, applied next
  var activeChoice = null;   // being written right now; wins over any server render in between
  function applyChoice(choice) {
    setBusy(true);
    activeChoice = choice;
    var start = lastCart ? Promise.resolve(lastCart) : getCart();
    return start
      .then(function (cart) {
        var guess = Object.assign({}, cart, { attributes: Object.assign({}, cart.attributes, { shipping_protection: choice }) });
        project(guess);
        return reconcile(cart, choice);
      })
      .then(function (cart) { render(cart, analyse(cart)); })
      .catch(function (e) { if (window.console) console.warn('[shipping-protection]', e); })
      .then(finish);
  }
  function finish() {
    setBusy(false);
    activeChoice = null;
    if (queuedChoice) {
      var c = queuedChoice; queuedChoice = null;
      return applyChoice(c);
    }
    if (dirty) return refresh();
  }
  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (!t || !t.hasAttribute || !t.hasAttribute('data-ac-sp-toggle')) return;
    var choice = t.checked ? 'accepted' : 'declined';
    // Wait if we are mid-request, or if Empire is between a cart change and its own re-render
    // (re-rendering under it would make it reload the page).
    if (busy || themePending) { queuedChoice = choice; if (lastCart) project(lastCart); return; }
    applyChoice(choice);
  });

  // Watch the theme's own cart traffic (fetch and XHR) and re-tier after it.
  // On the cart page Empire follows every change with GET /cart?section_id=... and
  // re-renders the section from it; we wait for THAT request rather than the change
  // itself, so we never touch the DOM while Empire is mid-update.
  var onCartPage = !!document.querySelector('[data-section-type="static-cart"]');
  var themePending = false;  // cart page: Empire has changed the cart and not yet re-rendered
  var themePendingTimer = null;
  function themeStarted() {
    if (!onCartPage) return;
    themePending = true;
    clearTimeout(themePendingTimer);
    themePendingTimer = setTimeout(function () {
      themePending = false;
      if (queuedChoice && !busy) { var c = queuedChoice; queuedChoice = null; applyChoice(c); }
    }, 5000);
  }
  function themeSettled() {
    themePending = false;
    clearTimeout(themePendingTimer);
    scheduleRefresh();
  }
  function isTrigger(url) {
    if (typeof url !== 'string') return false;
    if (onCartPage) return /\/cart\?.*section_id=/.test(url);
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
  }
  // A cart mutation response from the theme lets us paint the projected fee and totals
  // straight away, before the reconcile round-trip.
  function isMutation(url) {
    return typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
  }
  function project(cart) {
    if (!cart || !cart.items) return;
    lastCart = cart;
    var a = analyse(cart);
    var choice = queuedChoice || activeChoice;
    var declined = choice ? choice === 'declined' : a.declined;
    var wantLine = !declined && a.goods > 0;
    var total = a.goods + (wantLine ? a.fee : 0);
    var shown = Object.assign({}, cart, { total_price: total });
    render(shown, a);
  }
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url);
    if (isMutation(url)) themeStarted();
    var p = origFetch.apply(this, arguments);
    if (isMutation(url)) {
      p.then(function (r) { r.clone().json().then(project, function () {}); }, function () {});
    }
    if (isTrigger(url)) p.then(themeSettled, function () {});
    return p;
  };
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isMutation(url)) {
      themeStarted();
      this.addEventListener('load', function () {
        try { project(JSON.parse(this.responseText)); } catch (e) {}
      });
    }
    if (isTrigger(url)) {
      this.addEventListener('loadend', themeSettled);
    }
    return origOpen.apply(this, arguments);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  window.ACShippingProtection = { refresh: refresh, analyse: analyse };
})();
